import "../../Projects/Galerie_Fanny/Galerie_Fanny.css";
import Hero from "../../Projects/Galerie_Fanny/Hero.jsx";
import AboutUs from "../../Projects/Galerie_Fanny/AboutUs.jsx";
import Card from "../../Projects/Galerie_Fanny/Card.jsx";
import Card2 from "../../Projects/Galerie_Fanny/Card2.jsx";
import Footer from "../../general/Footer.jsx";

export default function Galerie_Fanny() {
  return (
    <div className="GaFa-page">
      <Hero />
      <AboutUs />
      <Card />
      <Card2 />
      <Footer />
    </div>
  );
}
